export default __webpack_public_path__ + "static/media/right.45861910.png";